import { useState, useEffect } from 'react';
import {Header} from "./../../../components/userPage";
import ButtonMenu from "./Instruments/ButtonForTarifPlan";
import Modal from "./Instruments/Modal"
import { useLocation, useNavigate } from 'react-router-dom';
import './CardModal/style.css'
import translate from './../../Translate/balancePage.json';
import months from './../../Translate/months.json';
import { Invoice } from './InvoiceModal';
import { CardModal } from './CardModal';
import touchpointLogo from './CardModal/imgs/MoMo_Logo.png';
import touchpointLogoWebp from './CardModal/imgs/MoMo_Logo.webp';
import touchpointLogoAvif from './CardModal/imgs/MoMo_Logo.avif';
import { LoadingModal } from './LoadModal';
import { useLoading } from "./LoadModal/script";
import { getUser, getDecoders, updateDecoderPacks } from '../../../shared/service';

/** Локальный предпросмотр без сессии: только npm start + localhost / 127.0.0.1 */
const isBalanceDevPreviewHost = (hostname) =>
  process.env.NODE_ENV === 'development' &&
  (hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]');


const MOCK_DECODERS_PREVIEW = [
  {
    decoder_id: '37-511893',
    packs: [
      { pack_id: 1, name: 'Free Douala', cost: 0, one_time: false, expire: '2026-04-06' },
      { pack_id: 2, name: 'Total Douala', cost: 18000, one_time: false, expire: '2026-02-05' },
    ],
  },
  {
    decoder_id: '37-256702',
    packs: [
      { pack_id: 3, name: 'Magic Douala', cost: 5000, one_time: false, expire: '2026-03-01' },
      { pack_id: 4, name: 'Charme Douala', cost: 8000, one_time: false, expire: '2026-03-15' },
      { pack_id: 5, name: 'Canal+ Douala', cost: 12000, one_time: false, expire: '2026-04-01' },
      { pack_id: 6, name: 'Passion Douala', cost: 9000, one_time: false, expire: '2026-03-20' },
      { pack_id: 7, name: 'Magic+Passion Douala', cost: 15000, one_time: false, expire: null },
    ],
  },
];

const buildIsClickedFromDecoders = (decs) =>
  decs?.map((decoder) =>
    decoder.packs?.map((pack) => (!pack.one_time && pack.expire ? true : false)) ?? []
  ) ?? [[], []];

const Balance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [language, setLanguage] = useState('');
  const [previewMode, setPreviewMode] = useState(false);
  useEffect(() => {
    setLanguage(JSON.parse(localStorage.getItem('choosen-language')));
  }, [location, navigate])
  /////////////////////////////////////////////////////////////
  //current domain
  const currentURL = window.location.href;
  const url = new URL(currentURL);
  const domain = url.hostname;
  const balanceDevPreview = isBalanceDevPreviewHost(domain);
  
  /////////////////////////////////////////////////////////////
  //fetching info
  const [balance, setBalance] = useState(0);
  const [status, setCountryChooseStatus] = useState(true); 
  const [decoders, setDecoders] = useState(null);
  // const decoders = [{decoder_id: "95-26868355", packs: null}];
  const [modal, showModal] = useState(false); 
  const [isClicked, setIsClicked] = useState([[], []]);
  const [min, setMin] = useState(0);
  const [amount, setAmount] = useState(0);

  /////////////////////////////////////////////////////////////
  //fetching functions
  const fetchDecoders = async () => {
    try{
      const data = await getDecoders();
      const decs = data.decoders;
      const isClick = decs?.map((decoder) => decoder.packs?.map((pack) => {
        if(!pack.one_time && pack.expire){
          return true;
        }
        return false;
      })) || [[],[]];
      setIsClicked(isClick);
      setDecoders(decs);
    }
    catch(error){
      console.error('Error fetching', error);
      if (balanceDevPreview) {
        setPreviewMode(true);
        setDecoders(MOCK_DECODERS_PREVIEW);
        setIsClicked(buildIsClickedFromDecoders(MOCK_DECODERS_PREVIEW));
      }
    }
  }
  const {loader} = useLoading();
  const fetchBalance = async () => {

    try {
      const data = await getUser();
      setBalance(data.balance);
      setCountryChooseStatus(data.country !== null && data.region !== null);
    } catch (error) {
      console.error('Error fetching', error);
      if (balanceDevPreview) {
        setPreviewMode(true);
        setBalance(35000);
        setCountryChooseStatus(true);
        return;
      }
      navigate('/');
    }
  };

  const fetchChangings = async (item) => {
    try{
      await updateDecoderPacks(item);
      fetchDecoders();
      fetchBalance();
    }
    catch(error){
      console.error(error);
    }
  }
  /////////////////////////////////////////////////////////////
  //interface setters
  const converter = (param) => {
    if (!param.expire) return "Inactive";
    // else return param.expire;
    const arr = param.expire.split('-');
    return months[language][arr[1] - 1] + " " + arr[2] + ", " + arr[0]
  }

  const toogleChoose = (value, index, ind) => {
      const updated = [...isClicked];
      updated[index][ind] = value;
      setIsClicked(updated);
  }
  const deleteAll = (index) => {
      const updated = [...isClicked];
      updated[index] = isClicked[index].map(elem => elem = false)
      setIsClicked(updated);
  }

  //fetch changes
  const handleSubmit = (index) => {
    const packs = decoders[index].packs.map((pack, ind) => {  
      if(isClicked[index][ind]){
        return pack.pack_id;
      }
    }).filter((item) => item !== undefined)
    const fetchItem = {
        decoder_id: decoders[index].decoder_id,
        packs: packs,
    }
    fetchChangings(fetchItem);
  };

  const adaptiveInfo = (pack, blank) => {
    if (blank){ 
      if(window.innerWidth < 759) 
        return <td><button className="modal-show-btn">Show date</button></td>

      return <td>{translate.prase15[language]} <span className="pointed">.................</span></td>
    }

    if(window.innerWidth < 759) 
      return <td><Modal cancel={translate.prase20[language]} prase={pack.one_time ? translate.prase15[language] : translate.prase14[language]} date={converter(pack)}/></td>

    return <td>{pack.one_time ? translate.prase15[language] :  translate.prase14[language]} <span className="pointed">{converter(pack)}</span></td>
  }

  /////////////////////////////////////////////////////////////
  //useEffects
  useEffect(() => {
    loader(true);
    fetchDecoders();
    fetchBalance();
    setTimeout(() => {
      loader(false)
    }, 700)
    showModal(balance < min); 
  }, [location, navigate]);

  useEffect(() => {
    showModal(balance < min); 
  }, [balance, min]);

  useEffect(() => {
    const arr = decoders?.map((decoder) => decoder.packs?.map((pack) => {
      if(!pack.one_time && pack.expire){
        return pack.cost || 0;
      }
      return 0;
    }))
    const sum = arr?.reduce((acc, val) => acc + val?.reduce((a, v) => a + v, 0), 0)
    setMin(sum);
  }, [decoders])
  return(
        <div className="user">
            <Header/>
            <div className="user-body">
                {previewMode && (
                  <div
                    role="status"
                    style={{
                      padding: '6px 12px',
                      fontSize: 13,
                      textAlign: 'center',
                      background: '#2c3e50',
                      color: '#ecf0f1',
                    }}
                  >
                    Dev: страница баланса без API (localhost). Вход не требуется.
                  </div>
                )}
                <LoadingModal/>
                                              {modal && <div className="error-block"> 
                                <div className="error-massage">
                                  <h1> {translate.prase18[language]}</h1>
                                  <p>{translate.prase19[language]}</p>
                                  <button className="error-btn" onClick={() => {showModal(false)}}>{translate.prase20[language]}</button>
                                </div>
                              </div>} 
                <div className="balance-container-box" style={!decoders ? {top: "-5vh"} : {height: "100%"}}>
                  <div className='balance-container'>
                      <div className="user-profile-block-container">
                          <div className="user-profile-right-column"> {/*className="pointed"*/}
                              <p>{translate.prase1[language]} <span >{balance} CFA</span></p> {/**/}

                              <div style={{
                                  display: 'flex',
                                  maxWidth: '260px',
                                  flexDirection: 'column'
                              }}>
                                  <CardModal
                                    provider="MTN"
                                    translate={translate}
                                    language={language}
                                    minAmount={amount}
                                    triggerSrc={touchpointLogo}
                                    triggerSrcWebp={touchpointLogoWebp}
                                    triggerSrcAvif={touchpointLogoAvif}
                                    triggerAlt="Touchpoint"
                                  />
                                  <CardModal
                                    provider="OM"
                                    translate={translate}
                                    language={language}
                                    minAmount={amount}
                                  />
                                  <Invoice translate={translate} language={language}/>
                              </div>
                          </div>
                          <div className="user-profile-right-column">
                              <ButtonMenu min={min} balance={balance} language={language} setAmount={setAmount}/>
                          </div>
                      </div>
                  </div>
                </div> 
                <div className="packets-list-block">
                     {decoders ? decoders.map((decoder, index) => (  
                         <div className="packets-list-card" key={index}>
                             <div className="packets-list-card-header">
                                 <div>{translate.prase9[language]} <span className="pointed">{decoder.decoder_id}</span></div>
                                 <div><button disabled={!status} className={status ? "packets-list-apply" : ""} onClick={() => {if(status)handleSubmit(index)}}>{translate.prase17[language]}</button></div> {/**/}
                             </div>
                             <table style={{maxWidth: '100%', minWidth: '100%'}}>
                                 <thead><tr style={{textAlign:'center'}}><td colSpan={4}>{translate.prase21[language]}</td></tr></thead>
                                 <tbody>
                                   {decoder.packs?.map((pack, ind) => (
                                       <tr key={ind}>
                                           <td className="td-btn"><input style={status ? { boxShadow: '1px 1px 1px 1px #00000080' } : {}} type="checkbox" disabled={!status} checked={isClicked[index][ind]} onChange={(e) => {toogleChoose(e.target.checked, index, ind)}}/></td>{/*isClicked[index][ind]*/}
                                           <td>{pack.name}</td>
                                           <td>CFA <span className="pointed">{pack.cost}</span> {translate.prase10[language]} </td>
                                           {adaptiveInfo(pack, false)}
                                       </tr>   
                                   ))}
                                 </tbody>
                                 <tfoot><tr className="clickable" style={{textAlign:'center'}} onClick={() => {if(status)deleteAll(index)}}><td colSpan={4}>{translate.prase16[language]}</td></tr></tfoot> {/**/}
                             </table>
                         </div>
                     )):
                      (
                        <div className="packets-list-card">
                             <div className="packets-list-card-header">
                                 <div>{translate.prase9[language]} <span className="pointed">...</span></div>
                                 <div><button className={status ? "packets-list-apply" : ""}>{translate.prase17[language]}</button></div> {/**/}
                             </div>
                             <table style={{maxWidth: '100%', minWidth: '100%'}}>
                                 <thead><tr style={{textAlign:'center'}}><td colSpan={4}>{translate.prase21[language]}</td></tr></thead>
                                 <tbody>
                                       <tr>
                                           <td className="td-btn"><input style={status ? { boxShadow: '1px 1px 1px 1px #00000080' } : {}} type="checkbox" /></td>
                                           <td>.......</td>
                                           <td>CFA <span className="pointed">...</span> {translate.prase10[language]} </td>
                                           {adaptiveInfo({}, true)}
                                       </tr>
                                 </tbody>
                                 <tfoot><tr className="clickable" style={{textAlign:'center'}}><td colSpan={4}>{translate.prase16[language]}</td></tr></tfoot> 
                             </table>
                         </div>
                      )
                     }
                </div>
            </div>    
            
        </div>
    )
  }
export default Balance;